import { LS2PAC_Utils } from "@tlc/ls2pac/app/utils/Utils";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { useLocationConfiguration } from "@tlc/ls2pac/components/LocationConfiguration";
import * as React from "react";
import { ResourceDWR } from "../../../../dto/ResourceDWR";
import { Bookjacket, BookjacketProps } from "./Bookjacket";
import { RateAndReview } from "@tlc/ls2pac/components/rate-and-review/RateAndReview";
import { Button } from "@mui/material";
import { ReviewDialogProvider } from "../../../../contexts/ReviewDialogContext";
import { Link } from "react-router-dom";
import { RequestButton } from "@tlc/ls2pac/components/place-hold/RequestButton";

export interface ResourceListItemProps {
  resource: ResourceDWR;
  onClickRemove: (event: React.MouseEvent) => void;
}

export interface BookJacketAndRatingProps
  extends Omit<BookjacketProps, "resource"> {
  resource: ResourceDWR;
}

export const BookJacketAndRating: React.FC<BookJacketAndRatingProps> = ({
  id,
  resource,
}) => {
  if (!resource) {
    return null;
  }
  return (
    <div className="bookjacketContainer clearfix">
      <Link to={`/resource/${resource.id}/details`}>
        <Bookjacket id={id} resource={resource}></Bookjacket>
      </Link>
      {resource.rtype === 1 && (
        <div className="ratingsControl">
          <ReviewDialogProvider>
            <RateAndReview material={resource}></RateAndReview>
          </ReviewDialogProvider>
        </div>
      )}
    </div>
  );
};

interface RowHeaderProps {
  shortTitle: string;
  shortAuthor?: ResourceDWR["shortAuthor"];
  publicationDate?: ResourceDWR["publicationDate"]["publicationDate"];
  resourceId?: ResourceDWR["id"];
}
export const RowHeader: React.FC<RowHeaderProps> = ({
  shortTitle,
  shortAuthor,
  publicationDate,
  resourceId,
}) => {
  const { translate } = useLanguage();
  const pubDate = publicationDate ? "(" + publicationDate + ")" : "";

  return (
    <>
      <h2>
        {resourceId ? (
          <>
            <Link to={`/resource/${resourceId}`}>{shortTitle}</Link> {pubDate}
          </>
        ) : (
          <>
            {shortTitle} {pubDate}
          </>
        )}
      </h2>
      {shortAuthor && (
        <h3>
          {translate("by")} {shortAuthor}
        </h3>
      )}
    </>
  );
};

export interface ResourceRowHeaderProps {
  resource: ResourceDWR;
}
export const ResourceRowHeader: React.FC<ResourceRowHeaderProps> = ({
  resource,
}) => {
  return (
    <RowHeader
      resourceId={resource.id}
      publicationDate={resource?.publicationDate?.publicationDate}
      shortAuthor={resource.shortAuthor}
      shortTitle={resource.shortTitle}
    ></RowHeader>
  );
};

export const ResourceListItem: React.FC<ResourceListItemProps> = ({
  resource,
  onClickRemove,
}) => {
  const { translate } = useLanguage();
  const { locationConfiguration } = useLocationConfiguration();
  const showRequestButton = LS2PAC_Utils.showRequestButton(resource);

  return (
    <>
      <BookJacketAndRating resource={resource}></BookJacketAndRating>
      <div className="resourceContentWrapper lightBorder">
        <div className="resourceContent">
          <ResourceRowHeader resource={resource}></ResourceRowHeader>
          {resource.rtype === 1 && (
            <Link
              to={`/resource/${resource.id}/copies`}
              className="allCopies availabilityLink"
            >
              {translate("checkAvailability")}
            </Link>
          )}
          <ul className="resultActions clearfix">
            {resource.rtype === 1 &&
              showRequestButton &&
              !resource.downloadable &&
              locationConfiguration?.pacSettings?.userActionSettings
                ?.allowOnShelfHolds && (
                <li className="requestButtonHolder">
                  <RequestButton resource={resource}></RequestButton>
                </li>
              )}
            <li>
              <Button className="removeListItem" onClick={onClickRemove}>
                {translate("removeFromList")}
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
